export const IMG_BASE = 'assets/img/map';

// ── セッション管理 ──────────────────────────────────────
export const SESSION_KEY = 'kaiho-biku:visited';

// ── ローディング ────────────────────────────────────────
/** 初回訪問時の最小表示時間（2回目以降は sessionStorage により 0 になる） */
export const MIN_LOADING_MS_FIRST_VISIT = 2000;

// ── HowTo オーバーレイ ──────────────────────────────────
/** HowTo 表示開始までのディレイ（PC はロゴアニメ後、SP は即時） */
export const HOWTO_SHOW_DELAY_MS_PC = 2500;
export const HOWTO_SHOW_DELAY_MS_SP = 0;
/** HowTo 表示後、自動で閉じるまでの時間 */
export const HOWTO_DISPLAY_MS = 4000;

// ── PC/SP 判定ブレークポイント ───────────────────────────
export const PC_BREAKPOINT_PX = 1024;
